// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-check-label {
  font-size: 0.78rem;
  color: #374151;
  line-height: 1.45;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/electronic-entry-signature/electronic-entry-signature.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".form-check-label {\n  font-size: 0.78rem;\n  color: #374151;\n  line-height: 1.45;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
